import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypeCreationFailedAction = {
	type: 'DOCUMENT_TYPE_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypeCreationFailedAction => ({
	type: 'DOCUMENT_TYPE_CREATION_FAILED',
	payload,
});
